var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Default',[_c('div',{staticClass:"variable"},[_c('Stock'),_c('Decentralized'),_c('Transaction'),_c('QAndA'),_c('CPopup',{ref:"popModule"},[_c('Module')],1),_c('CPopup',{ref:"popDvantage"},[_c('Dvantage')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }